import React, { useEffect, useState } from 'react'
import { Modal } from 'reactstrap'

import arrowLeft from 'Shared/icons/arrow-left.svg'
import closeCross from 'Shared/icons/close-cross.svg'
import SearchInput from 'Containers/ui/Input'

import ListComponent from 'Containers/ui/ParamsSelect/ListComponent'
import { GreenBtn, GreyBtnDisabled } from 'Stories/Button/Button.stories'
import { useTranslation } from 'react-i18next'
import { IconCheckMarkWhite } from 'Stories/Icon/Icon.stories'
import { ParamsSelectProps, SelectItem } from './ParamsSelectTypes'
import { CampaignPlatformTypeEnum } from '../../../Types'

import {
  BackButtonWrapper,
  ButtonContainer,
  CloseButtonWrapper,
  SearchInputWrapper,
  SmallButton,
} from './styles'

const ParamsSelect: React.FunctionComponent<ParamsSelectProps> = ({
  isSearchMode,
  listedItems,
  selectedItems,
  placeholder,
  itemsType,
  setSelectedItems,
  // flow,
  // campaignId,
  onCloseClick,
  hidePlaylistsCount,
}) => {
  const [chosenListIsOpen, setChosenListIsOpen] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string | undefined>('')

  const { t } = useTranslation()

  const onClearInput = () => {
    setSearchValue('')
  }

  const onChange = (e: string) => {
    setSearchValue(e && e.toLowerCase())
    setChosenListIsOpen(false)
  }

  const [localSelectItems, setLocalSelectItems] = useState<Array<SelectItem>>(
    []
  )

  useEffect(() => {
    setLocalSelectItems(selectedItems)
  }, [selectedItems])

  const onSaveHandler = () => {
    setSelectedItems(localSelectItems)
    onCloseClick()
  }
  return (
    <>
      <Modal
        fade={false}
        className="modal__mobile-dialog params-select"
        isOpen={isSearchMode}
        modalClassName="modal__mobile"
      >
        <SearchInputWrapper>
          <BackButtonWrapper>
            <SmallButton onClick={onCloseClick}>
              <img src={arrowLeft} alt="back-button" />
            </SmallButton>
          </BackButtonWrapper>

          <SearchInput
            required
            autoFocus
            id="searchInput"
            name="searchInput"
            type="text"
            value={searchValue}
            placeholder={placeholder}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange(e.target.value)
            }
          />
          {searchValue && (
            <CloseButtonWrapper>
              <SmallButton onClick={onClearInput}>
                <img src={closeCross} alt="clear-button" />
              </SmallButton>
            </CloseButtonWrapper>
          )}
        </SearchInputWrapper>
        <ListComponent
          // @ts-ignore
          searchValue={searchValue}
          chosenListIsOpen={chosenListIsOpen}
          setChosenListIsOpen={setChosenListIsOpen}
          itemsType={itemsType}
          listedItems={listedItems}
          campaignType={CampaignPlatformTypeEnum.SPOTIFY}
          selectedItems={localSelectItems}
          setSelectedItems={setLocalSelectItems}
        />
        {localSelectItems.length > 0 ? (
          <ButtonContainer>
            <GreenBtn color="green" onClick={onSaveHandler}>
              <IconCheckMarkWhite />
              {t('targetGenres.save')}
            </GreenBtn>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <GreyBtnDisabled color="greyDisabled">
              <IconCheckMarkWhite />
              {t('targetGenres.save')}
            </GreyBtnDisabled>
          </ButtonContainer>
        )}
      </Modal>
    </>
  )
}

export default ParamsSelect
